import Registry from "../plugins/Registry";

export default class CreditCalc {
  static get(selector) {
    let instance = Registry.get('Form', selector);
    if (instance)
      return instance;

    instance = new CreditCalc(selector);
    Registry.set('CreditCalc', selector, instance);

    return instance;
  }

  constructor(selector) {
    this.selector = selector;

    if (typeof selector === 'string')
      this.object = $(this.selector);
    else
      this.object = this.selector;

    this.init();
    return this;
  }

  init() {
    this.setData();
    this.setEvents();
    return this;
  }

  setData() {
    this.data = {
      MIN_CREDIT_PERCENT: 0.15,
      MIN_CREDIT: 100000,
      MAX_CREDIT_PERCENT: 0.5,
      MAX_CREDIT: 1500000,
      SZH: 0.00167,
      GAP: 0.0,
      MONTH: 12,
      SROK: 12,
      STAVKA: 0.085
    };

    this.updateVars();

    this.bars = this.object.find('[bar]');
    this.advantages = this.object.find('.model-advantage');

    return this;
  }

  updateVars() {
    this.data.STAVKA_PER_MONTH = this.data.STAVKA / this.data.MONTH;
    this.data.YEARS = this.data.SROK / this.data.MONTH;
  }

  setEvents() {
    const self = this;
    self.bars.each(function () {

      const slider = $(this),
        price = parseInt(slider.attr('price')),
        max = self.getMaxPV(price),
        min = self.getMinPV(price),
        start = parseInt($.number(Math.floor(min + (max - min) / 2), 0, '', ''));

      slider.slider({
        min: min,
        max: max,
        value: start,
        change: (e, obj) => self.putVals(self, obj, self),
        slide: (e, obj) => self.putVals(self, obj, self)
      });

      slider.parents('form').find('.price__amount span').text($.number(start, 0, '', ' ') + ' руб.');
      slider.parents('form').find('.price__count span').text(self.getPrice(price, start) + ' руб.');

    });

    if (self.object.find('[name="srok"]').length) {
      self.object.find('[name="srok"]').on('change', function () {
        self.data.SROK = $(this).val();
        self.data.STAVKA = parseFloat($(this).attr('data-stavka')) * 0.01;
        self.updateVars();
        self.bars.each(function () {
          $(this).slider('value', $(this).slider('value'));
        });
      });
    }

    if (self.object.find('[name="compl"]').length) {
      self.object.find('[name="compl"]').on('change', function () {
        const modif = $(this).attr('data-mod'),
          compl = $(this).val();

        const price = parseInt($('[data-name="compl"]').find('.active').data('price')),
          max = self.getMaxPV(price),
          min = self.getMinPV(price),
          start = parseInt($.number(Math.floor(min + (max - min) / 2), 0, '', ''));

        self.setAdvantages(modif, compl);

        self.bars.each(function () {
          $(this).attr('price', price);
          $(this).slider('option', {
            min: min,
            max: max,
            value: start,
          });
        });

      });
    }
  }

  getMaxPV(price) {
    return (price + this.data.GAP * price * this.data.YEARS - (this.data.MIN_CREDIT * (1 - this.data.SZH * this.data.YEARS)));
  }

  getMinPV(price) {

    const pv = (price + this.data.GAP * price * this.data.YEARS - (this.data.MAX_CREDIT * (1 - this.data.SZH * this.data.YEARS)));
    return (pv < price * this.data.MIN_CREDIT_PERCENT) ? price * this.data.MIN_CREDIT_PERCENT : pv;

  }

  setAdvantages(modif, compl) {
    if (this.advantages.length === 0) return;
    this.advantages.map((index, el) => $(el).removeClass('active'));
    this.advantages
        .filter(
          (index, el) =>
            (
              $(el).data('mod-id') === parseInt(modif) &&
              $(el).data('compl-id') === parseInt(compl)
            )
        )
        .addClass('active');
  }

  putVals(creditCalc, obj, self) {
    let value = $.number(obj.value, 0, '', ' '),
      $obj = $(obj.handle),
      form = $obj.parents('form'),
      carPrice = parseInt($obj.parent().attr('price'));

    const textVal = self.getPrice(carPrice, obj.value) + ' руб.',
      price = form.find('.price__count');

    form.find('.price__amount span').text(value + ' руб.');
    price.find('span').text(textVal);
  }

  getPrice(price, PV) {
    if (price === 0)
      return '';

    const toCredit = price - PV,
      credit = toCredit + parseFloat($.number((toCredit) / (1 - this.data.SZH * this.data.SROK) - (toCredit), 2, '.', '')); // credit price + strahovanie zhizni
    return $.number(Math.floor(this.pmt(this.data.STAVKA_PER_MONTH, this.data.SROK, credit * -1)), 0, '', ' ');
  }

  /**
   * Copy of Excel's PMT function.
   * Credit: http://stackoverflow.com/questions/2094967/excel-pmt-function-in-js
   *
   * @param rate_per_period       The interest rate for the loan.
   * @param number_of_payments    The total number of payments for the loan in months.
   * @param present_value         The present value, or the total amount that a series of future payments is worth now;
   *                              Also known as the principal.
   * @returns {number}
   */
  pmt(rate_per_period, number_of_payments, present_value) {
    const q = Math.pow(1 + rate_per_period, number_of_payments);
    return -(rate_per_period * ((q * present_value))) / ((-1 + q));
  }
}
